module.exports = __webpack_public_path__ + "img/9_003.ae6f167c.webp";